import { Redirect } from 'react-router-dom'
import { renderRoutes } from 'react-router-config'
import Main from './pages/Main'
import Login from './pages/Login'
import IncomeStatement from './pages/IncomeStatement'
import IncomeStatements from './pages/IncomeStatements'
import DeliveryStatements from './pages/DeliveryStatements'
import T4ALogin from './pages/T4ALogin'
import T4AInfo from './pages/T4AInfo'
import T4ADownload from './pages/T4ADownload'

function ProtectedRoute({ route }) {
  const token = window.localStorage.getItem('auth_token')
  return token ? (
    renderRoutes(route.routes)
  ) : (
    <Redirect to='/driverMobile/login' />
  )
}

const routes = [
  {
    path: '/t4a-login',
    component: T4ALogin
  },
  {
    path: '/t4a-info',
    component: T4AInfo
  },
  {
    path: '/t4a-download',
    component: T4ADownload
  },
  {
    path: '/driverMobile/login',
    component: Login
  },
  {
    path: '/login',
    exact: true,
    render: () => {
      return <Redirect to={'/driverMobile/login'}></Redirect>
    }
  },
  {
    component: ProtectedRoute,
    routes: [
      {
        path: '/driverMobile/main',
        component: Main
      },
      {
        path: '/driverMobile',
        exact: true,
        render: () => {
          return <Redirect to={'/driverMobile/main'}></Redirect>
        }
      },
      {
        path: '/',
        exact: true,
        render: () => {
          return <Redirect to={'/driverMobile/main'}></Redirect>
        }
      },
      {
        path: '/driverMobile/incomeStatement',
        component: IncomeStatement
      },
      {
        path: '/driverMobile/incomeStatements',
        component: IncomeStatements
      },
      {
        path: '/driverMobile/deliveryStatements',
        component: DeliveryStatements
      }
    ]
  }
]

export default routes
